import barba from '@barba/core';
import gsap from 'gsap';
import load from './load';
import loader from './loader';
const { init: loaderStart, stop: loaderStop } = loader;

const filters = Array.from(document.querySelectorAll('.js-work-filter'));
const container = document.querySelector('#ajax-items-container');
const activeCatClass = 'category-is-active';
const activeSubCatClass = 'sub-category-is-active';
const activeSubListClass = 'sub-list-is-active';

function updateHistory(url) {
  barba.history.add(url, 'barba');
}

function getProjects(tween) {
  const url = tween.data;
  // axios.get(url);
  return barba.request(url, 10000);
}

function handleRes(res) {
  console.log('handle res');
  // Get new page content
  const parser = new DOMParser();
  const resHTML = parser.parseFromString(res, "text/html");
  const itemsContainer = resHTML.querySelector('#ajax-items');
  // Replace container content
  container.innerHTML = '';
  container.append(itemsContainer);
}

function animStart(url) {
  return gsap.to(container, {
    data: url,
    opacity: 0,
    duration: 0.1,
  });
}

function animEnd() {
  const tl = gsap.timeline();
  const cards = Array.from(container.querySelectorAll('.js-animate-in'));
  return tl.to(container, {
    opacity: 1,
    duration: 0.1
  })
  .to(cards, {
    opacity: 1,
    y: 10,
    duration: 0.2,
    stagger: 0.1,
  });
}

function updateProjects(url) {
  loaderStart();
  animStart(url)
  .then(getProjects)
  .then(handleRes)
  .then(loaderStop)
  .then(animEnd)
  .catch(err => console.log(err));
}

function updateClasses(filter) {
  const filterType = filter.dataset.filterType;
  if (filterType === 'category') {
    // Update active parent filters
    const activeCat = document.querySelector(`.${activeCatClass}`);
    activeCat.classList.remove(activeCatClass);
    filter.parentElement.classList.add(activeCatClass);
    // Update active child filter list
    const activeSubList = document.querySelector(`.${activeSubListClass}`);
    const catId = filter.dataset.categoryId;
    const newActiveSubList = document.querySelector(`[data-parent-category="${catId}"]`);
    activeSubList.classList.remove(activeSubListClass);
    newActiveSubList.classList.add(activeSubListClass);
    // Set active child filter to 'all'
    const activeSubCat = document.querySelector(`.${activeSubCatClass}`);
    activeSubCat.classList.remove(activeSubCatClass);
    newActiveSubList.firstElementChild.classList.add(activeSubCatClass);
  }
  if (filterType === 'sub-category') {
    // Update active parent filters
    const activeSubCat = document.querySelector(`.${activeSubCatClass}`);
    activeSubCat.classList.remove(activeSubCatClass);
    filter.parentElement.classList.add(activeSubCatClass);
  }
}

function handleFilter(e) {
  e.preventDefault();
  const clicked = e.currentTarget;
  const url = clicked.href;
  updateClasses(clicked);
  updateHistory(url);
  updateProjects(url);
}

function init() {
  if (!filters.length) {
    return;
  }
  filters.forEach(filter => {
    filter.addEventListener('click', handleFilter);
  });
}

init();
